/* tslint:disable */
/* eslint-disable */
/**
 * comici-plus-api
 * # Comici Plus API v1  コンテンツプロバイダーがコンテンツの配信サイトを作成するために利用するAPIを提供します。 
 *
 * The version of the OpenAPI document: 1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { EpisodeSearchModel } from './EpisodeSearchModel';
import {
    EpisodeSearchModelFromJSON,
    EpisodeSearchModelFromJSONTyped,
    EpisodeSearchModelToJSON,
} from './EpisodeSearchModel';
import type { SeriesAuthorSearchModel } from './SeriesAuthorSearchModel';
import {
    SeriesAuthorSearchModelFromJSON,
    SeriesAuthorSearchModelFromJSONTyped,
    SeriesAuthorSearchModelToJSON,
} from './SeriesAuthorSearchModel';
import type { SeriesSearchModel } from './SeriesSearchModel';
import {
    SeriesSearchModelFromJSON,
    SeriesSearchModelFromJSONTyped,
    SeriesSearchModelToJSON,
} from './SeriesSearchModel';

/**
 * 検索APIにより返される検索結果を表します。
 * 作者の作品、作品、エピソードそれぞれの検索結果が含まれます。
 * @export
 * @interface SearchResultModel
 */
export interface SearchResultModel {
    /**
     * 
     * @type {SeriesSearchModel}
     * @memberof SearchResultModel
     */
    series?: SeriesSearchModel;
    /**
     * 
     * @type {EpisodeSearchModel}
     * @memberof SearchResultModel
     */
    episode?: EpisodeSearchModel;
    /**
     * 
     * @type {SeriesAuthorSearchModel}
     * @memberof SearchResultModel
     */
    seriesByAuthor?: SeriesAuthorSearchModel;
}

/**
 * Check if a given object implements the SearchResultModel interface.
 */
export function instanceOfSearchResultModel(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function SearchResultModelFromJSON(json: any): SearchResultModel {
    return SearchResultModelFromJSONTyped(json, false);
}

export function SearchResultModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): SearchResultModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'series': !exists(json, 'series') ? undefined : SeriesSearchModelFromJSON(json['series']),
        'episode': !exists(json, 'episode') ? undefined : EpisodeSearchModelFromJSON(json['episode']),
        'seriesByAuthor': !exists(json, 'seriesByAuthor') ? undefined : SeriesAuthorSearchModelFromJSON(json['seriesByAuthor']),
    };
}

export function SearchResultModelToJSON(value?: SearchResultModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'series': SeriesSearchModelToJSON(value.series),
        'episode': EpisodeSearchModelToJSON(value.episode),
        'seriesByAuthor': SeriesAuthorSearchModelToJSON(value.seriesByAuthor),
    };
}

